import { SelectedAnzeige } from './../selected-anzeige';
import { Component, OnInit } from '@angular/core';
import { RestApiService } from "../shared/rest-api.service";
import { ActivatedRoute } from '@angular/router';
import {FormGroup, FormControl, Validators, ReactiveFormsModule, NgForm} from '@angular/forms';
import { on_off_animation } from '../animations/animations';
import { Config } from "../shared/config";


@Component({
    selector: "app-anzeigen-detail",
    templateUrl: "./anzeigen-detail.component.html",
    styleUrls: ["./anzeigen-detail.component.scss"]
    // animations: [on_off_animation],
    // host: { '[@on_off_animation]': ''}
})
export class AnzeigenDetailComponent implements OnInit {
    panelOpenState = false;
    Details: any = [];
    selA: SelectedAnzeige;
    usernameKerze: string = "";
    usermailKerze: string = "";
    usernameKondolenz: string = "";
    usermailKondolenz: string = "";
    kondolenzText: string = "";
    isSent = false;
    isSentKondolenz = false;
    // baseURLKerze: string = "http://localhost:3000/";
    kartenId;
    formOk: boolean = false;
    kundenId:string = "";
    kerzenError = false;
    kondolenzError = false;



    KerzenArr: any = [];
    KondolenzenArr: any = [];
    KarteArr: any = [];

    verstorbenenName: string ="";
    verstorbenenVorName: string ="";
    verstorbenenGeburtsdatum: string ="";
    verstorbenenSterbedatum: string ="";


    formKondolenz = new FormGroup({
        name: new FormControl("", [
            Validators.required,
            Validators.minLength(2),
        ]),
        // email: new FormControl("", [Validators.required, Validators.email]),
        email: new FormControl("", [Validators.required]),
        kondolenz: new FormControl("", [
            Validators.required,
            Validators.minLength(3),
        ]),
        // datenschutzKondolenz: new FormControl("", [Validators.required]),
        datenschutzKondolenz: new FormControl("", [Validators.required]),
    });

    formKerze = new FormGroup({
      name: new FormControl("", [
          Validators.required,
          Validators.minLength(2),
      ]),
      email: new FormControl("", [Validators.required, Validators.email]),
      datenschutzKerze: new FormControl("", [Validators.required]),
  });

    constructor( public restApi: RestApiService,  private route: ActivatedRoute,  private slA: SelectedAnzeige, public conf: Config ) {
        // console.log("###################1909----------------------------------------------------------------- "+JSON.stringify(slA));
        this.selA = slA;
        this.kundenId = conf.kundenId;
    }
 
    ngOnInit(): void {
        const routeParams = this.route.snapshot.paramMap;
        const productIdFromRoute = Number(routeParams.get("anzeigenId"));
        // console.log(
        //     "-----productIdFromRoute----------->" +
        //         JSON.stringify(productIdFromRoute)
        // );
        this.Details = { make: "" };
        this.loadDetails(productIdFromRoute);
        this.kartenId = productIdFromRoute;
        //this.loadKarte(this.kartenId);
        // console.log("-------------------------> "+JSON.stringify(this.selA.a_trauerkarte));
    }

    // Get Details
    loadDetails(f) {
        return this.restApi.getDetail(f).subscribe((data: {}) => {
            this.Details = data;
            this.KerzenArr = this.Details[0];
            this.KondolenzenArr = this.Details[1];
            this.KarteArr = this.Details[2];
            this.verstorbenenName = this.KarteArr[0]['ta_name'];
            this.verstorbenenVorName = this.KarteArr[0]['ta_firstname'];
            this.verstorbenenGeburtsdatum = this.KarteArr[0]['ta_birthdate'];
            this.verstorbenenSterbedatum = this.KarteArr[0]['ta_deathdate'];
            // console.log("1--> "+JSON.stringify(this.Details[0]));
            // console.log("2--> "+JSON.stringify(this.Details[1]));
            // console.log("3--> "+JSON.stringify(this.Details[2]));
        });
    }

    // loadKarte(kartenId){
    //     return this.restApi.getKartenDetail(kartenId).subscribe((data: {}) => {
    //         this.Details = data;
    //         console.log("12--------------> "+JSON.stringify(this.Details));
    //     });
    // }

    email = new FormControl("", [Validators.required, Validators.email]);

    getErrorMessage() {
        if (this.email.hasError("required")) {
            return "You must enter a value";
        }

        return this.email.hasError("email") ? "Not a valid email" : "";
    }

    sendFormValues() {
        if(this.formKerze.valid){
                const headers = { "content-type": "application/json" };
                var kerzeData = {
                    usermail: this.usermailKerze,
                    username: this.usernameKerze,
                    kartenId: this.kartenId,
                    baseURL: window.location.origin+"#/confirm",
                    kundenId: this.kundenId
                };
                const body = JSON.stringify(kerzeData);

                this.restApi.setKerze(body);
                this.isSent = true;
                this.kerzenError = false;
        }
        else{
            this.kerzenError = true;
        }
    }

    sendFormValuesKondolenz() {

        if(this.formKondolenz.valid){
        const headers = { "content-type": "application/json" };
        var kondolenzData = {
            usermail: this.usermailKondolenz,
            username: this.usernameKondolenz,
            kondolenzText: this.kondolenzText,
            kartenId: this.kartenId,
            baseURL: window.location.origin+"#/confirm",
            kundenId: this.kundenId
        };
        const data = JSON.stringify(kondolenzData);

        this.restApi.setKondolenz(data);
        this.isSentKondolenz = true;
        this.kondolenzError = false;
    }
        else{
            this.kondolenzError = true;
        }

    }
    

    nlTobr( text){
        return text.replace(/(?:\r\n|\r|\n)/g, '<br>');;
    }

}